module.exports = __webpack_public_path__ + "static/media/hunts.b72fa899.png";